import { render, staticRenderFns } from "./UserBanner.vue?vue&type=template&id=65aec26b&"
import script from "./UserBanner.vue?vue&type=script&lang=js&"
export * from "./UserBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65aec26b')) {
      api.createRecord('65aec26b', component.options)
    } else {
      api.reload('65aec26b', component.options)
    }
    module.hot.accept("./UserBanner.vue?vue&type=template&id=65aec26b&", function () {
      api.rerender('65aec26b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Page/UserProfile/UserBanner.vue"
export default component.exports